<template>
  <b-modal
    class="modal-form-objective text-muted"
    id="modal-form-objective"
    centered
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    size="s"
    title="Add Objective KPI"
  >
    <b-form-group
      label="Name Objective"
    >
      <b-form-input
        v-model="newObjective"
        placeholder="Enter Objective KPI"
        required
      ></b-form-input>
    </b-form-group>
    <div>
      <b-button
        class="text-white"
        block
        variant="warning"
        @click="createNewObjective"
      >
        Add
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    employees: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newObjective: '',
      optionsEmployee: []
    }
  },
  methods: {
    createNewObjective() {
      this.$emit('create', this.newObjective)
      this.$bvModal.hide('modal-form-objective')
    }
  }
}
</script>
